import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { lifecycle, nest, compose } from 'recompose'
import styles from './styles.scss'
import FontIcon from 'react-toolbox/lib/font_icon'
import ProgressBar from 'react-toolbox/lib/progress_bar'

import {
  updatePreviewShow
} from './actions'

import {
  filePreviewLinkSelector,
  filePreviewLoadingSelector,
  filePreviewNameSelector,
  filePreviewShowSelector,
  nextFileSelector,
  prevFileSelector
} from './selectors'
import { 
  fetchFileForPreview 
} from '../FileSection/actions'

const mapStateToProps = (state) => {
  return {
    fileLink: filePreviewLinkSelector(state),
    loading: filePreviewLoadingSelector(state),
    fileName: filePreviewNameSelector(state),
    show: filePreviewShowSelector(state),
    nextFile: nextFileSelector(state),
    prevFile: prevFileSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFileForPreview: (id, name) => dispatch(fetchFileForPreview(id, name)),
    updatePreviewShow: (show) => dispatch(updatePreviewShow(show))
  }
}

class FilePreview extends Component {

  constructor(props){
    super(props)
    this.keyPressed = this.keyPressed.bind(this)
  }

  componentDidMount(){
    document.addEventListener("keydown", this.keyPressed, false);
  }

  componentWillUnmount(){
    document.removeEventListener("keydown", this.keyPressed, false);
  }

  closeOverlay(){
    this.props.updatePreviewShow(false)
  }

  goToNextImage(){
    const {
      fileId, 
      name
    } = this.props.nextFile
    this.props.fetchFileForPreview(fileId, name)
  }

  goToPrevImage(){
    const {
      fileId, 
      name
    } = this.props.prevFile
    this.props.fetchFileForPreview(fileId, name)
  }

  getPreview(){
    if(this.props.loading){
      return (
        <ProgressBar theme={styles} type="circular" mode="indeterminate" />
      )
    } else {
      return (
        <img styleName='image' src={this.props.fileLink} />
      )
    }
  }

  getFileName(){
    if(!this.props.loading){
      return(
        <div styleName='fileNameContainer'>
          <div styleName='fileName'>{this.props.fileName}</div>
        </div>
      )
    }
    return null
  }

  keyPressed(e){
    if(this.props.show){
      switch(e.key){
        case 'ArrowRight':
          this.goToNextImage()
          break
        case 'ArrowLeft':
          this.goToPrevImage()
          break
        case 'Escape':
          this.closeOverlay()
          break
        default:
          break
      }
    }
  }

  getOverlay(){
    return (
      <div styleName='overlay'>

        {this.getFileName()}

        <div styleName='prevButtonContainer' onClick={() => this.goToPrevImage()}>
          <FontIcon value='chevron_left' className={styles.prevIcon}/>
        </div>

        <div styleName='nextButtonContainer' onClick={() => this.goToNextImage()}>
          <FontIcon value='chevron_right' className={styles.nextIcon}/>
        </div>

        <div styleName='closeButtonContainer' onClick={() => this.closeOverlay()}>
          <FontIcon value='close' className={styles.closeIcon}/>
        </div>

        <div styleName='previewContainer'>
          {this.getPreview()}
        </div>

      </div>
    )
  }

  render(){
    if(this.props.show){
      return this.getOverlay()
    } 
    return null
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(FilePreview)
